export { usePointsBoostSurfacesConfig } from './use-points-boost-surfaces-config';
